module.exports = __webpack_public_path__ + "static/media/editor.d1d8d819.png";